export default __webpack_public_path__ + "static/media/KirstyPhotoTablet.45070341.jpg";